import React, { useState } from 'react'
import { ErrorDialog } from '../components/ui/ErrorDialog'

type UseErrorDialogReturn = {
    openErrorDialog: boolean
    errorMessage: React.ReactNode
    showError: (message: React.ReactNode) => void
    hideError: () => void
    ErrorDialogComponent: React.FC<{ title?: string }>
}

export const useErrorDialog = (): UseErrorDialogReturn => {
    const [openErrorDialog, setOpenErrorDialog] = useState<boolean>(false)
    const [errorMessage, setErrorMessage] = useState<React.ReactNode>('')

    const showError = (message: React.ReactNode): void => {
        setErrorMessage(message)
        setOpenErrorDialog(true)
    }

    const hideError = (): void => {
        setOpenErrorDialog(false)
        setErrorMessage('')
    }

    const ErrorDialogComponent: React.FC<{ title?: string }> = ({ title }) => (
        <ErrorDialog
            open={openErrorDialog}
            message={errorMessage}
            onClose={hideError}
            title={title}
        />
    )

    return {
        openErrorDialog,
        errorMessage,
        showError,
        hideError,
        ErrorDialogComponent,
    }
}
